import React from 'react';
import { Card, CardContent, Divider, Typography } from '@mui/material';
import {
  Edit,
  SimpleForm,
  NumberInput,
  TextInput,
  BooleanInput,
  Toolbar,
  SaveButton,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  SelectInput,
} from 'react-admin';
import { useResourceAccess } from '../../hooks/useAccess';

const CustomToolbar = (props: any) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

const ApiConfig: React.FC = () => {
  const { SettingsDetailsEdit } = useResourceAccess();
  const isRo = !SettingsDetailsEdit();
  return (
    <Card>
      <CardContent>
        <Edit
          resource="config"
          id={''}
          redirect={false}
          actions={false}
          title=" (Credit Card)"
          mutationMode={'pessimistic'}
        >
          <SimpleForm toolbar={!isRo ? <CustomToolbar /> : false}>
            <NumberInput source="interest" disabled={isRo} />
            <TextInput source="adequateExplanationsDocumentS3Key" disabled={isRo} />
            <BooleanInput source="newCardsCreditBuilderOn" disabled={isRo} />
            <BooleanInput source="autoPaymentOn" label="Auto Lock On" disabled={isRo} />
            <ReferenceArrayInput
              source="staff"
              reference="usermanagement"
              filter={{ searchOnly: true }}
              disabled={isRo}
            >
              <AutocompleteArrayInput
                filterToQuery={(t: string) => ({ email: t })}
                optionText={'email'}
                disabled={isRo}
              />
            </ReferenceArrayInput>
            <BooleanInput source="authEnsureMFAEnabled" disabled={isRo} />
            <NumberInput source="authEnsureMFAForGetPinEveryMinutes" disabled={isRo} />
            <NumberInput source="authEnsureMFAForGetSecretEveryMinutes" disabled={isRo} />
            <NumberInput source="authEnsureMFAForSetPinEveryMinutes" disabled={isRo} />
            <NumberInput source="authEnsureMFAForUpdateKBAEveryMinutes" disabled={isRo} />
            <Divider sx={{ width: '100%', my: 2 }} />
            <Typography variant="h6">Credit limit increase automation</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2, maxWidth: 600 }}>
              An automated job reviews eligible customers and raises their credit limits in small steps. It reads these
              settings before every run. If the switch below is off, the job does nothing.
            </Typography>
            <BooleanInput
              source="creditLimitIncreaseEnabled"
              label="Credit Limit Increase On"
              helperText="Master switch for the automation. Off means the job does nothing, whatever the mode says. Turn this off to stop it immediately."
              disabled={isRo}
            />
            <SelectInput
              source="creditLimitIncreaseMode"
              label="Credit Limit Increase Mode"
              choices={[
                { id: 'dry-run', name: 'Dry run (score only, no changes)' },
                { id: 'shadow', name: 'Shadow (read live data, still no changes)' },
                { id: 'apply', name: 'Apply (real increases)' },
              ]}
              helperText="Dry run: the job only scores customers and writes a report. Shadow: it also reads live account data to check its decisions, but changes nothing. Apply: it makes real credit limit increases."
              parse={(v: string) => (v === '' ? null : v)}
              disabled={isRo}
            />
            <NumberInput
              source="maxIncreasesPerDay"
              label="Max Increases Per Day"
              min={0}
              step={1}
              helperText="Maximum number of increases the job may apply in one day. Leave blank for no daily cap."
              disabled={isRo}
            />
          </SimpleForm>
        </Edit>
      </CardContent>
    </Card>
  );
};

export default ApiConfig;
